/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DxTrialLeadControllerCaptureMutationRequest, DxTrialLeadControllerCaptureMutationResponse, DxTrialLeadControllerCapture401, DxTrialLeadControllerCapture403, DxTrialLeadControllerCapture404 } from "../../models/dxTrialsController/DxTrialLeadControllerCapture";

function getDxTrialLeadControllerCaptureUrl() {
  const res = { method: 'POST', url: `/api/v1/dx-trial-leads` as const }  
  return res
}

/**
 * @summary Capture a trial lead ahead of Trimble ID signup
 * {@link /api/v1/dx-trial-leads}
 */
export async function dxTrialLeadControllerCapture(data?: DxTrialLeadControllerCaptureMutationRequest, config: Partial<RequestConfig<DxTrialLeadControllerCaptureMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DxTrialLeadControllerCaptureMutationResponse, ResponseErrorConfig<DxTrialLeadControllerCapture401 | DxTrialLeadControllerCapture403 | DxTrialLeadControllerCapture404>, DxTrialLeadControllerCaptureMutationRequest>({ method : "POST", url : getDxTrialLeadControllerCaptureUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}